/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbChiclet as AbChicletInternal } from "abreact/misc/AbChiclet";
import * as React from "react";

/**
 * The properties for the **AbChiclet** component.
 */

/**
 * The **AbChiclet** component shows the user a chosen value.
 * [[include:absdk/preliminary/commons/ui/input/AbChiclet.md]]
 */
export const AbChiclet = props => {
  return /*#__PURE__*/React.createElement(AbChicletInternal, props);
};
//# sourceMappingURL=AbChiclet.js.map
